import { Pills } from '@amelio/ui-library';

import type { CalibrationAdjustmentStatus } from '@/types/calibration';

import { useAmelioTranslations } from '@/hooks';

export interface AdjustmentStatusPillProps {
    /** `null` when the employee has no calibration adjustment yet. */
    status: CalibrationAdjustmentStatus | null;
    dataTestId?: string;
}

/**
 * Small badge sitting beside an employee's name once their calibration has a lifecycle to report.
 * A row nobody has touched shows nothing at all: a placeholder repeated down every line would say
 * less than the blank space it fills.
 */
export const AdjustmentStatusPill = ({ status, dataTestId }: AdjustmentStatusPillProps) => {
    const { t } = useAmelioTranslations();

    if (status === null) {
        return null;
    }

    return (
        <Pills
            size={'sm'}
            variant={status === 'Draft' ? 'lightPurple' : 'default'}
            dataTestId={dataTestId}
        >
            {status === 'Draft'
                ? t('calibration.table.status.draft')
                : t('calibration.table.status.published')}
        </Pills>
    );
};
